import { render, staticRenderFns } from "./Umbrella.vue?vue&type=template&id=37579930&scoped=true&"
import script from "./Umbrella.vue?vue&type=script&lang=ts&"
export * from "./Umbrella.vue?vue&type=script&lang=ts&"
import style0 from "./Umbrella.vue?vue&type=style&index=0&id=37579930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37579930",
  null
  
)

export default component.exports